import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
  CREATE_ENTITY_TYPE_URL,
  CREATE_SUB_ENTITY_TYPE_URL,
  get_headers,
  get_token,
  LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
  UNASSIGN_SUB_ENTITY_TYPE_URL,
  UPDATE_ENTITY_TYPE_URL,
  VIEW_ENTITY_TYPE_URL,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  validate_non_empty_string,
  validate_non_sub_zero_number
} from '@/utils/validations/validate_inputs';
import SubEntities from "@/views/probaworkflows_base/management/entity_management/manage_sub_entities/SubEntities.vue";
import axios from 'axios';
import $ from 'jquery';

export default {
  name: 'ManageEntityType',
  components: {
    GlobalTable,
    SubEntities,
    NavigationBackButton
  },
  mixins: [alert_mixin],
  data: () => ({
      headers: '',
      trust_type_name: '',
      trust_type_description: '',
      trust_type_count: 0,
      trust_types: [],
      trust_types_headers: [],
      table_safe_trust_types: [],
      edit_trust_type_name: '',
      edit_trust_type_description: '',
      edit_trust_type_id: null,
      token: get_token(),
      project_id: sessionStorage.getItem('project_id'),
      active_tab: "Entity Types",
      tabs: [
        "Entity Types",
      ],
      selected_subentity: '',
      selected_subentities: [],
      sub_entities: [], // checkboxes to show
      subentity_options: [],
      show_subentities_section: false,
      new_subentities: [''],
      current_form: { parent_id: null, parent_name: '', child_id: '' },
      available_children: [
      ],
      show_assign_modal: false,
      all_children: [],
      assign_datatable: null,
      datatable_key: 0,
      table_render_key: 0,

  }),

  mounted() {
    this.headers = get_headers();
    this.view_created_trust_type();

    const $modal_el = $('#assign_sub_entity_modal');
    if ($modal_el.length) {
      $modal_el.on('shown.bs.modal', () => {
        this.init_assign_table();
      });

      $modal_el.on('hidden.bs.modal', () => {
        this.destroy_assign_table();
      });
    }

  },
  methods: {
    // Method to create new entity type and add it to the table
    async create_trust_type() {
      if (!this.validate_create_trust_type_inputs()) return;

      var entity_type_name = this.trust_type_name;
      var entity_type_description = this.trust_type_description;
      const project_id = Number.isInteger(Number(this.project_id)) ? Number(this.project_id) : 0;

      const data = {
        entity_type_name: entity_type_name,
        entity_type_description: entity_type_description,
        project_id: project_id,
        entity_type_category: 1,
        sub_entities: [
          ...this.new_subentities.filter(name => name.trim() !== ''),
          ...this.sub_entities
            .filter(entity => this.selected_subentities.includes(entity.id))
            .map(entity => entity.sub_entity_name)
        ]
      };



      try {
        let response = await axios.post(CREATE_ENTITY_TYPE_URL, data, {
          headers: this.headers
        });

        const response_data = response.data;

        if (response_data.status === 'success') {
          this.show_success('Entity type has been created successfully.');
          this.close_modal('create_trust_type');
          this.trust_type_name = '';
          this.trust_type_description = '';
          window.setTimeout(() => {
            this.view_created_trust_type();
          }, 300);
        } else {
          this.show_error('Error during the form submit');
          this.close_modal('create_trust_type');
        }
      }
      catch (error) {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        }
      }

    },


    set_active_tab(tab) {
      this.active_tab = tab;
      sessionStorage.setItem("active_tab", tab);
    },

    // Method to view all created entity types
    async view_created_trust_type() {
      this.trust_types = [];

      const project_id = parseInt(this.project_id, 10);

      if (!validate_non_sub_zero_number(project_id)) {
        this.show_error('Project Id must not be null');
        return;
      }

      const params = { project_id: project_id };

      try {
        let response = await axios.get(VIEW_ENTITY_TYPE_URL, {
          headers: this.headers,
          params: params
        });

        const response_data = response.data;
        if (response_data.status === 'success') {
          this.trust_types = response_data.data;
          this.trust_type_count = response_data.count;
          this.all_children = Array.isArray(this.trust_types)
            ? this.trust_types.slice()
            : [];
          this.available_children = this.all_children;
          this.prep_tables();
        }
        else {
          this.show_error('Error during the form submit');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error('Error during the form submit:', error.response.data.message);
        }
      }
    },

    prep_tables() {
      const TABLE_SAFE_TRUST_TYPES = (this.trust_types || []).map(trust_type => ({
        "id": trust_type.id,
        "Entity Type": trust_type.entity_type_name,
        "Description": trust_type.entity_type_description,
      }));

      this.table_safe_trust_types = TABLE_SAFE_TRUST_TYPES;
      this.trust_types_headers = TABLE_SAFE_TRUST_TYPES.length
        ? Object.keys(TABLE_SAFE_TRUST_TYPES[0])
        : ["id", "Entity Type", "Description"];
      this.table_render_key += 1;
    },

    // Method to update the entity type
    async edit_trust_type() {
      if (!this.validate_edit_trust_type_inputs()) return;

      var new_entity_type_name = this.edit_trust_type_name;
      var new_entity_type_description = this.edit_trust_type_description;
      var entity_type_id = this.edit_trust_type_id;

      const data = {
        entity_type_name: new_entity_type_name,
        entity_type_description: new_entity_type_description,
        entity_type_id: entity_type_id
      };

      try {
        let response = await axios.post(UPDATE_ENTITY_TYPE_URL, data, {
          headers: this.headers
        });

        const response_data = response.data;
        if (response_data.status === 'success') {
          this.show_success('Entity type has been updated successfully.');
          this.close_modal('edit_trust_type');
          window.setTimeout(() => {
            this.view_created_trust_type();
          }, 300);
        } else {
          this.show_error('Error during the form submission');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        }
      }

    },

    prepopulate_edit_modal(row) {
      const original_trust = this.trust_types.find(type => type.id === row.id);
      if (original_trust) {
        this.edit_trust_type_name = original_trust.entity_type_name;
        this.edit_trust_type_description = original_trust.entity_type_description;
        this.edit_trust_type_id = original_trust.id;
      }
    },

    validate_create_trust_type_inputs() {
      if (!validate_non_empty_string(this.trust_type_name)) {
        this.show_error('Entity type name must not be empty');
        return false;
      }
      if (!validate_non_sub_zero_number(parseInt(this.project_id))) {
        this.show_error('Project Id must not be null');
        return false;
      }
      return true;
    },

    validate_edit_trust_type_inputs() {
      if (!validate_non_empty_string(this.edit_trust_type_name)) {
        this.show_error('Entity type name must not be empty');
        return false;
      }
      if (!validate_non_sub_zero_number(parseInt(this.edit_trust_type_id))) {
        this.show_error('Entity type id must not be null');
        return false;
      }
      return true;
    },
    redirect_to_view_entity(entity_type_id) {
      // Find the full entity object using the provided ID
      const selected_entity = this.trust_types.find(
        (entity) => entity.id === entity_type_id
      );

      // Store both ID and Name safely in sessionStorage
      sessionStorage.setItem('entity_type_id', entity_type_id);

      if (selected_entity && selected_entity.entity_type_name) {
        sessionStorage.setItem('entity_type_name', selected_entity.entity_type_name);
      } else {
        // Fallback in case entity_name is missing
        sessionStorage.setItem('entity_type_name', 'Unknown Entity Type');
      }

      // Redirect to the target page
      this.$router.push('/view_entity_type');
    },


    async open_assign_modal(entity_item) {
      const parent_id = Number(entity_item?.id);
      const parent_name = entity_item?.['Entity Type'] || '';
      this.show_assign_modal = true;

      this.current_form.parent_id = parent_id;
      this.current_form.parent_name = parent_name;
      this.show_assign_modal = true;

      try {
        const is_master_list_empty = !Array.isArray(this.all_children) || this.all_children.length === 0;
        if (is_master_list_empty) {
          await this.view_created_trust_type();
        }

        const assigned_children = await this.get_assigned_children(parent_id);
        const assigned_child_ids = new Set(
          (assigned_children || []).map(child => Number(child.child_entity_type_id))
        );

        // Build rows for this parent
        this.available_children = (this.all_children || [])
          .filter(child_item => Number(child_item.id) !== parent_id)
          .map(child_item => ({
            ...child_item,
            entity_type_name: child_item.entity_type_name ?? child_item.name ?? 'Unnamed',
            is_assigned: assigned_child_ids.has(Number(child_item.id)),
            is_loading: false,
          }));

        this.datatable_key += 1;
        await this.$nextTick(); // let Vue mount the new table DOM
        // DT will initialize via the 'shown.bs.modal' listener
      } catch (error) {
        this.show_error('Something went wrong while opening the assign modal.');
      }
    },


  async get_assigned_children(parent_entity_type_id) {
    const res = await axios
      .get(
        LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
        {
          headers: this.headers,
          params: { parent_entity_type_id },
        }
      )
      .catch(error => {
        const msg = error?.response?.data?.message
          || error?.message
          || 'Failed to load assigned children.';
        this.show_error(msg);
        return { data: null }; // fallback so code doesn’t break
      });

    if (!res?.data || res.data?.status !== 'success') {
      this.show_error('Could not load assigned children.');
      return [];
    }

    // Support both shapes: flat array OR { assigned_children: [...] }
    const payload = res.data?.data;
    this.displayed_assigned_children = payload;
    return Array.isArray(payload)
      ? payload
      : (payload?.assigned_children || []);
  },

  extract_error_message(error) {
    if (!error) {
      return "Unknown error occurred.";
    }


    if (error?.response?.data) {
      const response_data = error.response.data;

      if (Array.isArray(response_data.errors) && response_data.errors.length > 0) {
        return response_data.errors[0];
      }


      if (response_data.detail) {
        return response_data.detail;
      }

      if (response_data.message) {
        return response_data.message;
      }


      return JSON.stringify(response_data);
    }

    if (error?.message) {
      return error.message;
    }

    // Final fallback
    return "Request failed. Please try again.";
  },


  async on_toggle_assign(child, evt) {
    const target_checked = evt.target.checked;
    const parent_id = Number(this.current_form?.parent_id);
    const child_id = Number(child?.id);

    if (!parent_id || !child_id) {
      // revert the visual toggle
      evt.target.checked = !target_checked;
      this.show_error("Missing parent or child id.");
      return;
    }

    child.is_loading = true;

    try {
      if (target_checked) {
        await axios.post(
          CREATE_SUB_ENTITY_TYPE_URL,
          {
            parent_id: parent_id,
            child_id: child_id,
          },
          { headers: this.headers }
        );
        child.is_assigned = true;
      } else {
        await axios.post(
          UNASSIGN_SUB_ENTITY_TYPE_URL,
          {
            parent_id: parent_id,
            child_id: child_id,
          },
          { headers: this.headers }
        );
        child.is_assigned = false;
      }
    } catch (error) {
      evt.target.checked = !target_checked;

      // Extract and format the error message
      const raw_error_message = this.extract_error_message(error);

      this.show_error(raw_error_message);
    } finally {
      child.is_loading = false;
    }
  },

    init_assign_table() {
      const sel = '#assign_sub_entity_table';
      if ($.fn.DataTable.isDataTable(sel)) {
        $(sel).DataTable().destroy();
      }
      this.$nextTick(() => {
        this.assign_datatable = $(sel).DataTable({
          destroy: true,      // extra safety // sort by name
          language: {
            search: 'Filter:',
            lengthMenu: 'Show _MENU_',
            info: 'Showing _START_ to _END_ of _TOTAL_',
            infoEmpty: 'No entries',
            zeroRecords: 'No matching sub-entities found',
          },
        });
      });
    },

    destroy_assign_table() {
      const sel = '#assign_sub_entity_table';
      if ($.fn.DataTable.isDataTable(sel)) {
        $(sel).DataTable().clear().destroy();
      }
      this.assign_datatable = null;
    },

    close_assign_modal() {
      this.show_assign_modal = false;
    },


    reinit_assign_table() {
      this.destroy_assign_table();
      this.init_assign_table();
    },

    opening_assign_modal(row) {
      //For opening a modal directly:
      this.$emit('open-assign-modal', row);
    },

  },

};

